import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { HomeguardGuard } from './services/homeguard.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module').then( m => m.WelcomePageModule)
    // canActivate: [HomeguardGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
    // canActivate: [HomeguardGuard]
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then( m => m.AccountPageModule),
    canActivate: [AuthGuardService]
  },
  
  {
    path: 'adduser',
    loadChildren: () => import('./adduser/adduser.module').then( m => m.AdduserPageModule)
  },

  // {
  //   path: 'requisition',
  //   loadChildren: () => import('./requisition/requisition.module').then( m => m.RequisitionPageModule)
  // },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },

  {
    path: 'dash-completeness-act',
    loadChildren: () => import('./dash-completeness-act/dash-completeness-act.module').then( m => m.DashCompletenessActPageModule)
  },
  {
    path: 'modal-popover',
    loadChildren: () => import('./modal-popover/modal-popover.module').then( m => m.ModalPopoverPageModule)
  },
  // {
  //   path: 'sanction',
  //   loadChildren: () => import('./sanction/sanction.module').then( m => m.SanctionPageModule)
  // },
  // {
  //   path: 'sanction-list',
  //   loadChildren: () => import('./sanction-list/sanction-list.module').then( m => m.SanctionListPageModule)
  // },
 
  {
    path: 'modal-approve',
    loadChildren: () => import('./modal-approve/modal-approve.module').then( m => m.ModalApprovePageModule)
  },
  // {
  //   path: 'modal-genvouch',
  //   loadChildren: () => import('./modal-genvouch/modal-genvouch.module').then( m => m.ModalGenvouchPageModule)
  // },
  {
    path: 'examine',
    loadChildren: () => import('./examine/examine.module').then( m => m.ExaminePageModule)
  },
 
  // {
  //   path: 'modal-examine',
  //   loadChildren: () => import('./modal-examine/modal-examine.module').then( m => m.ModalExaminePageModule)
  // },
  {
    path: 'addfiles',
    loadChildren: () => import('./addfiles/addfiles.module').then( m => m.AddfilesPageModule)
  },
 
  // {
  //   path: 'modal-deletereq',
  //   loadChildren: () => import('./modal-deletereq/modal-deletereq.module').then( m => m.ModalDeletereqPageModule)
  // },
 
  // {
  //   path: 'modal-budgetdetail',
  //   loadChildren: () => import('./modal-budgetdetail/modal-budgetdetail.module').then( m => m.ModalBudgetdetailPageModule)
  // },
  {
    path: 'modal-ccdetail',
    loadChildren: () => import('./modal-ccdetail/modal-ccdetail.module').then( m => m.ModalCcdetailPageModule)
  },
  {
    path: 'usermanager',
    loadChildren: () => import('./usermanager/usermanager.module').then( m => m.UsermanagerPageModule)
  },
  {
    path: 'modal-roles',
    loadChildren: () => import('./modal-roles/modal-roles.module').then( m => m.ModalRolesPageModule)
  },
  {
    path: 'modal-sms',
    loadChildren: () => import('./modal-sms/modal-sms.module').then( m => m.ModalSmsPageModule)
  },
 
  {
    path: 'addvideo',
    loadChildren: () => import('./addvideo/addvideo.module').then( m => m.AddvideoPageModule)
  },
  {
    path: 'managevideo',
    loadChildren: () => import('./managevideo/managevideo.module').then( m => m.ManagevideoPageModule)
  },
  {
    path: 'viewvideoadmin',
    loadChildren: () => import('./viewvideoadmin/viewvideoadmin.module').then( m => m.ViewvideoadminPageModule)
  },
  {
    path: 'add-publication',
    loadChildren: () => import('./add-publication/add-publication.module').then( m => m.AddPublicationPageModule)
  },
  {
    path: 'managepublications',
    loadChildren: () => import('./managepublications/managepublications.module').then( m => m.ManagepublicationsPageModule)
  },
  {
    path: 'viewpublications-admin',
    loadChildren: () => import('./viewpublications-admin/viewpublications-admin.module').then( m => m.ViewpublicationsAdminPageModule)
  },
  {
    path: 'addevent',
    loadChildren: () => import('./addevent/addevent.module').then( m => m.AddeventPageModule)
  },
  {
    path: 'manageevents',
    loadChildren: () => import('./manageevents/manageevents.module').then( m => m.ManageeventsPageModule)
  },
  {
    path: 'viewevents',
    loadChildren: () => import('./viewevents/viewevents.module').then( m => m.VieweventsPageModule)
  },
  {
    path: 'videos',
    loadChildren: () => import('./videos/videos.module').then( m => m.VideosPageModule)
  },
  {
    path: 'publications',
    loadChildren: () => import('./publications/publications.module').then( m => m.PublicationsPageModule)
  },
  {
    path: 'blog',
    loadChildren: () => import('./blog/blog.module').then( m => m.BlogPageModule)
  },
  {
    path: 'blogdetail',
    loadChildren: () => import('./blogdetail/blogdetail.module').then( m => m.BlogdetailPageModule)
  },
  {
    path: 'event-details',
    loadChildren: () => import('./event-details/event-details.module').then( m => m.EventDetailsPageModule)
  },
  {
    path: 'partners',
    loadChildren: () => import('./partners/partners.module').then( m => m.PartnersPageModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then( m => m.AboutPageModule)
  },
  {
    path: 'managesubscribers',
    loadChildren: () => import('./managesubscribers/managesubscribers.module').then( m => m.ManagesubscribersPageModule)
  },

 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
